import React, { Component } from 'react';

import editIcon from '../../assets/images/edit-icon.svg';
import infoIcon from '../../assets/images/info-icon.svg';
import { joinClasses, classNameWithMods } from '../../utils/helpers';
import '../Tooltip/Tooltip.scss';

/** @import {SectionProps, SectionState} from './SectionTypes' */

/** @extends {Component<SectionProps, SectionState>} */
export default class Section extends Component {
  constructor(/** @type {SectionProps} */ props) {
      super(props);

        this.popupRef = React.createRef();

        this.state = {
            popupOpen: false,
            valid: !!this.props.valid,
            modifiers: this.props.modifiers ? this.props.modifiers : [],
            showTooltip: this.props.showTooltip ? this.props.showTooltip : false,
            hideEditing: this.props.hideEditing ? this.props.hideEditing : false,
            closeEditingOnConfirm: this.props.closeEditingOnConfirm ? this.props.closeEditingOnConfirm : true,
            infoTop: 0,
            infoLeft: 0
        };
    }

    // Lifecycle method to handle prop updates
    componentDidUpdate(/** @type {SectionProps} */ prevProps) {
        if (prevProps.valid !== this.props.valid) {
            this.setState({ valid: !!this.props.valid });
        }
    }


    togglePopup = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
        event.preventDefault();

        let button = event.currentTarget;
        let rect = button.getBoundingClientRect();
        let prect = button.offsetParent?.getBoundingClientRect();

        this.setState(({ popupOpen }) => ({
            popupOpen: !popupOpen,
            infoTop: rect.top - (prect?.top || 0) + 31,
            infoLeft: rect.left - (prect?.left || 0) - 16
        }));
    };

    startEditing = () => {
        this.props.onStart && this.props.onStart();
        this.props.setEditing && this.props.setEditing(true);
    };

    cancelEditing = () => {
        this.props.onCancel && this.props.onCancel();
        this.props.setEditing && this.props.setEditing(false);
    };

    approveEditing = async () => {
        if (this.props.validation && !(await this.props.validation()))
            return;

        if (this.state.closeEditingOnConfirm) {
          this.props.setEditing && this.props.setEditing(false);
        }

        this.props.onSave && this.props.onSave();
    };

    render() {
        return (
            <div className={joinClasses(this.props.className, classNameWithMods("my-profile__section", ...this.state.modifiers))}>
              <div className="my-profile__section-title">
                <div>
                  <span>{this.props.title}</span>
                </div>
                {this.state.showTooltip &&
                  <>
                    <div className='tooltip__text'>
                    {this.state.popupOpen && <div ref={this.popupRef}
                      className={['tooltip__blended-popup', this.state.popupOpen ? 'is-open' : ''].join(' ')}
                      style={{ top: this.state.infoTop, left: this.state.infoLeft }} dangerouslySetInnerHTML={
                        //@ts-expect-error unsure how to solve this from a TypeScript perspective
                        {__html: this.props.tooltipContent}
                        }>
                    </div>}
                    </div>
                  </>
                }
              </div>
              {this.props.children}
              <div className="my-profile__button-wrapper">
                {!this.state.hideEditing &&
                  <>
                    <button className={classNameWithMods('my-profile__edit-button', this.props.editing ? 'hidden' : '')} onClick={this.startEditing}><img src={editIcon} title="Edit" />Edit</button>
                    <div className={classNameWithMods('my-profile__section-right', !this.props.editing ? 'hidden' : '')}>
                      <button className="button button--tertiary button--sml" onClick={this.cancelEditing}>Cancel</button>
                      <button className="button button--primary button--sml" onClick={this.approveEditing} disabled={!this.state.valid}>Save</button>
                    </div>
                  </>
                }
                {this.state.showTooltip &&
                  <a href="#" id={this.props.toolTipId} onClick={this.togglePopup}>
                    <img alt="info" className="tooltip__img" src={infoIcon} />
                  </a>
                }
              </div>
            </div>
        );
    }
}